import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_SOURCES,
  GET_INSTALLATION_SOURCES_SUCCESS,
  GET_INSTALLATION_SOURCES_ERROR,
  ADD_INSTALLATION_SOURCE,
  ADD_INSTALLATION_SOURCE_SUCCESS,
  ADD_INSTALLATION_SOURCE_ERROR,
  DELETE_INSTALLATION_SOURCE,
  DELETE_INSTALLATION_SOURCE_SUCCESS,
  DELETE_INSTALLATION_SOURCE_ERROR,
  GET_INSTALLATION_SOURCE,
  GET_INSTALLATION_SOURCE_SUCCESS,
  GET_INSTALLATION_SOURCE_ERROR,
  UPDATE_INSTALLATION_SOURCE,
  UPDATE_INSTALLATION_SOURCE_SUCCESS,
  UPDATE_INSTALLATION_SOURCE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/source';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationSource;
const installationSource = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationSource':
          key = 'add';
          break;
        case 'updateInstallationSource':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST SOURCES
    case GET_INSTALLATION_SOURCES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_INSTALLATION_SOURCES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_INSTALLATION_SOURCES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    // ADD SOURCE
    case ADD_INSTALLATION_SOURCE:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_INSTALLATION_SOURCE_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_SOURCE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // DELETE SOURCE
    case DELETE_INSTALLATION_SOURCE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_INSTALLATION_SOURCE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_SOURCE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET
    case GET_INSTALLATION_SOURCE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_SOURCE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_SOURCE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_SOURCE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_SOURCE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_SOURCE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default installationSource;



// WEBPACK FOOTER //
// ./reducers/installation/installationSource.js